import React, { useRef, useState } from "react";
import "./CabSearchBar.css";
import { Col, Form, FormGroup } from "reactstrap";
import { useNavigate } from "react-router-dom";

const CabSearchBar = () => {
  const pickupRef = useRef("");
  const dropRef = useRef("");
  const dateRef = useRef("");
  const timeRef = useRef("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!pickupRef.current.value.trim()) {
      newErrors.pickup = "Pickup location is required";
    }
    if (!dropRef.current.value.trim()) {
      newErrors.drop = "Drop location is required";
    }
    if (!dateRef.current.value) {
      newErrors.date = "Date is required";
    }
    if (!timeRef.current.value) {
      newErrors.time = "Time is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const searchHandler = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const searchData = {
      pickup: pickupRef.current.value,
      drop: dropRef.current.value,
      date: dateRef.current.value,
      time: timeRef.current.value,
    };

    // Store search data in localStorage
    localStorage.setItem("cabSearchData", JSON.stringify(searchData));

    navigate("/cabs/search", { state: searchData });
  };

  // Get today's date in YYYY-MM-DD format for min date
  const today = new Date().toISOString().split("T")[0];

  return (
    <Col lg="12">
      <div className="cab__search__bar">
        <h4 className="cab__search__title">
          <i className="ri-taxi-line"></i> Book Your Ride
        </h4>
        <Form className="cab__search__form" onSubmit={searchHandler}>
          <div className="cab__form__row">
            <FormGroup className="cab__form__group">
              <div className="cab__input__wrapper">
                <span className="cab__input__icon">
                  <i className="ri-map-pin-line"></i>
                </span>
                <div className="cab__input__content">
                  <label>Pickup Location</label>
                  <input
                    type="text"
                    placeholder="Enter pickup location"
                    ref={pickupRef}
                    className={errors.pickup ? "error" : ""}
                  />
                  {errors.pickup && (
                    <span className="error__text">{errors.pickup}</span>
                  )}
                </div>
              </div>
            </FormGroup>

            <FormGroup className="cab__form__group">
              <div className="cab__input__wrapper">
                <span className="cab__input__icon">
                  <i className="ri-map-pin-2-line"></i>
                </span>
                <div className="cab__input__content">
                  <label>Drop Location</label>
                  <input
                    type="text"
                    placeholder="Enter drop location"
                    ref={dropRef}
                    className={errors.drop ? "error" : ""}
                  />
                  {errors.drop && (
                    <span className="error__text">{errors.drop}</span>
                  )}
                </div>
              </div>
            </FormGroup>

            <FormGroup className="cab__form__group">
              <div className="cab__input__wrapper">
                <span className="cab__input__icon">
                  <i className="ri-calendar-line"></i>
                </span>
                <div className="cab__input__content">
                  <label>Date</label>
                  <input
                    type="date"
                    ref={dateRef}
                    min={today}
                    className={errors.date ? "error" : ""}
                  />
                  {errors.date && (
                    <span className="error__text">{errors.date}</span>
                  )}
                </div>
              </div>
            </FormGroup>

            <FormGroup className="cab__form__group">
              <div className="cab__input__wrapper">
                <span className="cab__input__icon">
                  <i className="ri-time-line"></i>
                </span>
                <div className="cab__input__content">
                  <label>Time</label>
                  <input
                    type="time"
                    ref={timeRef}
                    className={errors.time ? "error" : ""}
                  />
                  {errors.time && (
                    <span className="error__text">{errors.time}</span>
                  )}
                </div>
              </div>
            </FormGroup>

            <button type="submit" className="cab__search__btn">
              <i className="ri-search-line"></i>
              Search Cabs
            </button>
          </div>
        </Form>
      </div>
    </Col>
  );
};

export default CabSearchBar;
